import WeightingScaleIcon from '../../../icons/weighting-scale.svg';
import SimplifiedIcon from '../../../icons/Simplified.svg';
import PermanentIcon from '../../../icons/PermanentIcon.svg';
import disabilityInsurance from '../../../icons/disabilityInsurance.svg';
import { SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY, ADVISOR_BASIC_INFO_KEY ,
SESSION_STORAGE_SCHEDULE_APPOINTMENT_KEY,SESSION_STORAGE_PERM_LIFE_INSURANCE_OBJECT_KEY, SESSION_STORAGE_ABLTC_OBJECT_KEY } from '../../../sessionStorage';
const TERM = 'Term';
const PERM = 'Permanent';
const FULL_UW = 'FullUW';
const ACCEL = 'Acc';
const SIMPL = 'Simplified';
const LEVEL = 'Level';
const PERM_UL = 'UL';
const AB_LTC = 'ABLTC';
const DECR = 'Decreasing';
const PERM_WL = 'WL';

const ProductList = () => {
return [
    {
      name: 'Term Life Insurance',
      key: 'Term',
      href: '/Products/Term',
      //imageUrl:'/product-landing/term-insurance/hero-image.png',
      category: 'Life',
      categories: [TERM, FULL_UW, ACCEL, LEVEL],
      target: '_blank',
      icon: SimplifiedIcon,
      filterKey: 'term',
      quoteProductKey: '',
      submitCaseProductKey: 'Term Life',
      sessionKey : SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY,
      scheduleSessionKey: SESSION_STORAGE_SCHEDULE_APPOINTMENT_KEY
    },
    {
      name: 'Permanent Life Insurance',
      key: 'perm-insurance',
      href: '/Products/Perm',
      //imageUrl:'/product-landing/perm-insurance/hero-image.png',
      target: '_blank',
      icon: PermanentIcon,
      filterKey:'perm',
      sessionKey: SESSION_STORAGE_PERM_LIFE_INSURANCE_OBJECT_KEY,
    },
    {
      name: 'Asset Based/ Hybrid LTC',
      key: 'ABLTC',
      href: '/Products/ABLTC',
      //imageUrl:'/product-landing/asset-based-hybrid-ltc/hero-image.png',
      categories: [PERM, FULL_UW, ACCEL, AB_LTC],
      category: 'LTC',
      target: '_blank',
      icon: WeightingScaleIcon,
      filterKey: 'ltc',
      quoteProductKey: 'ABLTC',
      submitCaseProductKey: 'LTC',
      sessionKey : SESSION_STORAGE_ABLTC_OBJECT_KEY
    },
    {
      name: 'Traditional Long-Term-Care',
      key: 'traditional-long-term-care',
      href: '/activity/illustration',
      //imageUrl:'/product-landing/traditional-long-term-care/hero-image.png',
      categories: [PERM, FULL_UW, ACCEL, PERM_UL],
      category: 'Life',
      target: '_blank',
      icon: WeightingScaleIcon,
      filterKey: 'universalLife',
      quoteProductKey: 'Traditional UL',
      submitCaseProductKey: 'Traditional Universal Life',
      sessionKey : ADVISOR_BASIC_INFO_KEY
    },
    {
      name: 'Disability Insurance',
      key: 'disability-insurance',
      //imageUrl:'/product-landing/disability-insurance/hero-image.png',
      href: '/Products/ADI',
      categories: [],
      target: '_blank',
      icon: disabilityInsurance,
      filterKey: 'disability',
      submitCaseProductKey: 'DI'
  }
 ];
}

export { TERM, PERM, FULL_UW, ACCEL, SIMPL, LEVEL, PERM_UL, AB_LTC, DECR, PERM_WL, ProductList }



// WEBPACK FOOTER //
// ./src/components/Common/data/Products.js